import { render, staticRenderFns } from "./InventoryModalComponent.vue?vue&type=template&id=61ffc4da"
import script from "./InventoryModalComponent.vue?vue&type=script&lang=js"
export * from "./InventoryModalComponent.vue?vue&type=script&lang=js"
import style0 from "./InventoryModalComponent.vue?vue&type=style&index=0&id=61ffc4da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports